<script setup>
import {computed, onMounted, ref} from "vue";
import store from "@/store";
import {couponConf} from "@/utils/config";
import axiosApi from "@/utils/axiosApi";
import {useRoute} from "vue-router";
import LoginComponents from "@/components/login/LoginComponents.vue";
import RealName from "@/components/login/RealName.vue";
import SendSmsComponents from "@/components/login/SendSmsComponents.vue";
import {ElMessage} from "element-plus";
import router from "@/router";
import XmLogin from "@/components/login/xmLogin.vue";

const type = computed(() => couponConf["hbwl-xmair"])
const showLogin = ref(true)
const route = useRoute()
const coupon = ref({})
const account = computed(() => store.state.account)
const sendSms = ref(false)
const realname = ref(false)
const href = window.location.href
const order_from = computed(() => store.state.orderFrom)
onMounted(async () => {
  store.commit("getCoupon")
  store.commit("getOrderFrom")
  await store.dispatch("getAccounts")
  getCoupon()
})
const getCoupon = () => {
  showLogin.value = false
  new axiosApi({
    encode: 'site',
    method: "coupon/cat_coupon_detail",
    body: {
      cid: route.params.id
    }
  }).send(res => {
    if (res.message.code === "000") {
      res.data.detail = res.data.detail.filter(v => v.key.length && v.value.length)
      coupon.value = res.data
      let details = {}
      coupon.value.detail.forEach(v => {
        // details[v.key] = v.value
        try {
          details[v.key] = JSON.parse(v.value)
        } catch ($e) {
          details[v.key] = v.value
        }
      })
      coupon.value.detail = details
      document.title = coupon.value.name
    }
  })
}
const mobile = ref("")
const showPayLoading = ref(false)
const loading = ref(false)
const number = ref(1)
const payment = () => {
  if (!account.value?.cust_id) {
    showPayLoading.value = false
    showLogin.value = true
    return;
  }
  if (!mobile.value || !/^1[2-9]\d{9}$/.test(mobile.value)) {
    return ElMessage.error("请输入手机号")
  }
  if (!sendSms.value && type.value.login !== 'xm_air') {
    sendSms.value = true
    return;
  }
  sendSms.value = false
  loading.value = true
  let pay_params = JSON.stringify(type.value.login === 'xm_air' ? {
    access_token: account.value.access_token,
    user_id: account.value.user_id
  } : {cust_id: account.value.cust_id})
  new axiosApi({
    encode: 'site',
    method: "coupon/pay",
    body: {
      coupon_id: coupon.value.id,
      uid: account.value.uid,
      pay_type: type.value.login,
      pay_params,
      number: number.value,
      auto_coupon: "1",
      mobile: mobile.value,
      order_from: order_from.value
    },
    score_type: type.value.login
  }).send(res => {
    loading.value = false
    if (res.message.code !== "000" && res.message.code !== "7041") {
      return ElMessage.error(res.message.content)
    } else if (res.message.code === "7041") {
      realname.value = true
      return
    }
    if (type.value.login !== 'xm_air')
      router.replace({name: 'home', query: {order: res.data.ordersn}})
    else window.location.replace(res.data.url)
  }, () => loading.value = false)
}

const loginCallback = () => {
  showLogin.value = false
  if (Object.keys(account.value).length) {
    showPayLoading.value = true
  }
}
const total_miles = computed(() => {
  return Object.keys(coupon.value).length ? number.value * coupon.value?.score_data[type.value.login]?.discount : 0
})

const maxNumber = computed(() => {
  let balanceMiles = parseFloat(account.value?.balance_miles || 0)
  let couponMiles = parseFloat(coupon.value?.score_data?.scal?.discount || 0)
  console.log(balanceMiles, couponMiles)
  if (couponMiles < balanceMiles) {
    return Math.floor(balanceMiles / couponMiles)
  } else {
    return 1
  }
})
</script>

<template>
  <el-scrollbar class="hbwl-detail">
    <div class="card-info">
      <div class="card-info-title" v-if="Object.keys(coupon).length">
        <span>{{ coupon.detail?.title }}信息</span>
      </div>
      <div class="card-items">
        <div class="card-item" v-for="(item, index) in coupon.detail?.card_lst" :key="index">
          <el-image :src="item.img"/>
          <div class="coupon-its">
            <div><b>{{ item.name }}</b></div>
            <div class="coupon-detail">
              <el-text type="info"><b>数量：{{ item.number }}张</b></el-text>
              <el-text type="danger"><b>单价：￥{{ item.price }}</b></el-text>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="coupon-details" v-html="coupon.remark"></div>
  </el-scrollbar>
  <div class="hbwl-footer" v-if="Object.keys(coupon).length">
    <div class="price">
      <el-text :type="type.login === 'xm_air' ? 'primary' : 'danger'">
        {{ coupon?.score_data[type.login]?.discount }}
      </el-text>
      {{ type.login === 'xm_air' ? '积分' : '里程' }}
    </div>
    <div class="btn-buy">
      <el-button round :type="type.login === 'xm_air' ? 'primary' : 'danger'" size="large"
                 v-if="Object.keys(account).length"
                 :disabled="parseFloat(account.balance_miles) < parseFloat(coupon?.score_data[type.login]?.discount)"
                 @click="showPayLoading=true">
        立即兑换
      </el-button>
      <el-button round :type="type.login === 'xm_air' ? 'primary' : 'danger'" size="large" v-else
                 @click="showLogin=true">
        请登录
      </el-button>
    </div>
  </div>
  <login-components v-if="showLogin && type.login === 'scal'" :show-login="showLogin" @login="loginCallback"/>
  <xm-login :show-login="showLogin" :account="account" v-if="showLogin && type.login === 'xm_air'"
            @login="loginCallback"/>
  <send-sms-components v-if="sendSms" :show="sendSms" @sends="payment" :login-account="account"/>
  <real-name :dialog="realname" v-if="realname" :href="href"/>
  <el-drawer v-model="showPayLoading" direction="btt" class="pay-box" size="560">
    <template #header>
      <div class="header">
        <div class="header-logo">
          <el-image src="https://images.jifen360.com/hbwl/mini.png"/>
        </div>
        <div class="header-title">
          <h4>{{ coupon?.name }}</h4>
          <el-text type="info">
            {{ coupon?.title }}
          </el-text>
          <div class="price" v-if="Object.keys(coupon).length">
            <el-text :type="type.login === 'xm_air' ? 'primary' : 'danger'">
              {{ coupon?.score_data[type.login]?.discount }}
            </el-text>
            {{ type.login === 'xm_air' ? '积分' : '里程' }}
          </div>
        </div>
      </div>
    </template>
    <div>
      <el-text type="info">
        兑换成功后，激活码将以短信的形式发放至下方填写的手机号因手机号填写错误造成的损失由会员本人承担。
      </el-text>
    </div>
    <el-card class="cards">
      <div class="pay-numbers">
        <div class="pay-numbers-label">填写手机号</div>
        <div class="pay-number-value">
          <el-input v-model="mobile" placeholder="请输入接收激活码的手机号"/>
        </div>
      </div>
    </el-card>
    <el-card class="cards">
      <div class="pay-numbers">
        <div class="pay-numbers-label">兑换数量</div>
        <div class="pay-number-value">
          <el-input-number v-model="number" :max="maxNumber" :min="1"/>
        </div>
      </div>
    </el-card>
    <el-card class="cards">
      <div class="pay-numbers">
        <div class="pay-numbers-label">可用{{ type.login === 'xm_air' ? '积分' : '里程' }}</div>
        <div class="pay-number-value">
          {{ account?.balance_miles }}
        </div>
      </div>
      <div class="pay-numbers">
        <div class="pay-numbers-label">支付{{ type.login === 'xm_air' ? '积分' : '里程' }}</div>
        <div class="pay-number-value">
          {{ total_miles }}
        </div>
      </div>
    </el-card>
    <div class="btn">
      <el-button round :type="type.login === 'xm_air' ? 'primary' : 'danger'" :loading="loading" size="large"
                 :disabled="total_miles > account.balance_miles" @click="payment">立即兑换
      </el-button>
    </div>
  </el-drawer>
</template>

<style scoped lang="less">
.hbwl-detail {
  height: calc(100vh - 60px);

  .card-info {
    background: #ffffff;
    padding: 15px;

    .card-info-title {
      text-align: center;
      font-size: 1.45rem;
      margin-bottom: 10px;

      span {
        position: relative;

        &:after {
          content: "";
          position: absolute;
          background: rgba(120, 179, 197, 0.55);
          left: -15px;
          right: -15px;
          height: 10px;
          border-radius: 10px;
          bottom: 2px;
        }
      }
    }

    .card-item {
      display: flex;

      & + .card-item {
        margin-top: 15px;
      }

      //align-items: center;
      .el-image {
        width: 120px;
        margin-right: 5px;
        flex-basis: 120px;
      }

      .coupon-its {
        flex-basis: calc(100% - 125px);
        width: calc(100% - 125px);
        line-height: 1.55;

        .coupon-detail {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }

  /deep/ .coupon-details {
    img {
      width: 100% !important;
      margin-top: -5px;
    }
  }
}

.hbwl-footer {
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  box-sizing: border-box;
  padding: 15px;
}

.price {
  font-size: .85rem;
  margin-right: 10px;

  .el-text {
    font-size: 1.45rem;
  }
}

.pay-box {
  .header {
    display: flex;

    .header-logo {
      width: 90px;
      flex-basis: 90px;
      margin-right: 10px;
    }

    .header-title {
      width: calc(100% - 100px);
      flex-basis: calc(100% - 100px);
      line-height: 1.7;
    }
  }

  .el-card {
    margin: 15px 0;
    border-radius: 12px;

    .pay-numbers {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 0;

      & + .pay-numbers {
        //margin-top: 15px;
        border-top: var(--el-border);
      }
    }
  }

  .btn {
    text-align: center;

    .el-button {
      width: 90%;
      margin: auto;
    }
  }
}
</style>
